module.exports = __webpack_public_path__ + "img/chatting _ comment-text.b4b3ce54.svg";